<template>
  <div class="auth-form">
    <!--  header --->
    <div class="auth-head">
      <h2 class="auth-title">{{ headerTitle }}</h2>
      <p class="auth-subtitle" v-html="headerSubtitle"></p>
    </div>

    <!--  progress --->
    <div class="auth-steps">
      <span v-for="n in 4" :key="n" :class="{ done: n <= currentStep }"></span>
    </div>

    <!--  register Steps --->
    <v-form ref="register" class="ma-0 pa-0 auth-step-wrap" @submit.prevent>
      <transition name="step">
        <!-- sing up --->
        <div v-if="register" key="phone" class="auth-fields">
          <v-text-field
            v-model="phone"
            placeholder="0912-12xxxx7"
            outlined
            :label="$t('mobile')"
            class="rtl-text auth-input"
            prepend-inner-icon="mdi-cellphone"
            type="tel"
            inputmode="numeric"
            autocomplete="tel"
            clearable
            hide-details="auto"
            :rules="[mobileFormatRule]"
            @keydown.enter.prevent="sendOTPCode()"
          ></v-text-field>
          <div class="auth-actions">
            <v-btn :loading="loading" block depressed class="auth-btn auth-btn--primary" @click="sendOTPCode()">
              {{ $t("register") }}
            </v-btn>
          </div>
        </div>

        <!-- OTP --->
        <div v-else-if="OTPVerifyStep" key="otp" class="auth-fields">
          <v-text-field
            v-model="OTPcode"
            outlined
            :label="$t('send otp')"
            class="rtl-text auth-input otp-input"
            prepend-inner-icon="mdi-message-lock-outline"
            inputmode="numeric"
            autocomplete="one-time-code"
            hide-details="auto"
            @keydown.enter.prevent="confirmOTP()"
          ></v-text-field>
          <div class="auth-row">
            <span>{{ $t("resend code again") }}</span>
            <button type="button" class="auth-link auth-timer" :disabled="timer > 0" @click="resendOTP">
              <v-icon x-small :color="timer > 0 ? 'grey' : 'primary'">mdi-timer-outline</v-icon>
              {{ otpButtonText }}
            </button>
          </div>
          <div class="auth-actions">
            <v-btn :loading="loading" block depressed class="auth-btn auth-btn--primary" @click="confirmOTP()">
              {{ $t("verify code") }}
            </v-btn>
            <div class="auth-row">
              <span>{{ $t("wrong number") }}</span>
              <button type="button" class="auth-link" @click="EditPhone">{{ $t("edit phone number") }}</button>
            </div>
          </div>
        </div>

        <!-- setRegisterPass --->
        <div v-else-if="setRegisterPassword" key="password" class="auth-fields">
          <v-text-field
            v-model="password"
            outlined
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
            @click:append="showPassword = !showPassword"
            :label="$t('password')"
            class="rtl-text auth-input"
            prepend-inner-icon="mdi-lock-outline"
            autocomplete="new-password"
            hide-details="auto"
            :rules="[passwordChecks]"
          ></v-text-field>
          <v-text-field
            v-model="retypePassword"
            outlined
            :type="showPassword ? 'text' : 'password'"
            :label="$t('repeat password')"
            class="rtl-text auth-input"
            prepend-inner-icon="mdi-lock-check-outline"
            autocomplete="new-password"
            hide-details="auto"
            @keydown.enter.prevent="confirmPassInfo()"
          ></v-text-field>

          <!-- pass rules section -->
          <div class="rules-grid">
            <div
              v-for="r in passwordRuleList"
              :key="r.key"
              class="rule-line"
              :class="ruleClass(passwordChecks[r.key])"
            >
              <v-icon x-small :color="iconColor(passwordChecks[r.key])">{{ iconName(passwordChecks[r.key]) }}</v-icon>
              <span>{{ $t(r.label) }}</span>
            </div>
          </div>

          <div class="auth-actions">
            <v-btn block depressed class="auth-btn auth-btn--primary" @click="confirmPassInfo()">
              {{ $t("confirm password") }}
            </v-btn>
          </div>
        </div>

        <!-- setRegisterInfo --->
        <div v-else-if="setRegisterInfo" key="info" class="auth-fields">
          <v-text-field
            v-model="name"
            outlined
            :label="$t('name')"
            class="rtl-text auth-input"
            prepend-inner-icon="mdi-account-outline"
            autocomplete="given-name"
            hide-details="auto"
            clearable
          ></v-text-field>
          <v-text-field
            v-model="lastName"
            outlined
            :label="$t('last-name')"
            class="rtl-text auth-input"
            prepend-inner-icon="mdi-account-details-outline"
            autocomplete="family-name"
            hide-details="auto"
            clearable
            @keydown.enter.prevent="confirmInformation()"
          ></v-text-field>
          <div class="auth-actions">
            <v-btn :loading="loading" block depressed class="auth-btn auth-btn--primary" @click="confirmInformation()">
              {{ $t("save information") }}
            </v-btn>
          </div>
        </div>
      </transition>
    </v-form>

    <!--  return to login --->
    <template v-if="register">
      <div class="auth-divider">{{ $t("or") }}</div>
      <v-btn block depressed class="auth-btn auth-btn--ghost" @click="returnToLogin">
        <v-icon left small>mdi-login-variant</v-icon>
        {{ $t("log in") }}
      </v-btn>
    </template>

    <!--  footer --->
    <p class="auth-terms">
      {{ $t("login terms&condition") }}
      <a href="#">{{ $t("terms of use") }}</a>
      {{ $t("terms of service and policy") }}
      <a href="#">{{ $t("privacy policy half") }}</a>
      {{ $t("abriron is") }}
    </p>

    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import General from "@/Mixins/general";
export default {
  name: "RegisterForm",
  mixins: [General],
  props: {
    signUpSection: Boolean,
  },
  data: () => ({
    phone: "",
    OTPcode: "",
    OTPtype: "loginByOtp",
    OTPtypeValidate: "validateOtp",
    password: "",
    retypePassword: "",
    name: "",
    lastName: "",
    register: true,
    OTPVerifyStep: false,
    setRegisterInfo: false,
    setRegisterPassword: false,
    mobileFormatRule: null,
    snakbar: false,
    snakbarColor: null,
    loading: false,
    snakbarText: null,
    timer: 120,
    showPassword: false,
  }),
  created() {
    this.mobileFormatRule = (value) => {
      const regex = /^(\+98|0)?9\d{9}$/;
      return regex.test(value) ? true : this.$t("invalid mobile format");
    };
  },
  computed: {
    currentStep() {
      if (this.setRegisterInfo) return 4;
      if (this.setRegisterPassword) return 3;
      if (this.OTPVerifyStep) return 2;
      return 1;
    },
    passwordRuleList() {
      return [
        { key: "length", label: "min length 8" },
        { key: "upperLower", label: "must include uppercase and lowercase" },
        { key: "number", label: "must include number" },
        { key: "symbol", label: "must include symbol" },
      ];
    },
    passwordChecks() {
      const pass = this.password || "";
      return {
        length: pass.length >= 8,
        upperLower: /[A-Z]/.test(pass) && /[a-z]/.test(pass),
        number: /\d/.test(pass),
        symbol: /[^A-Za-z0-9]/.test(pass),
      };
    },
    formattedTime() {
      const minutes = Math.floor(this.timer / 60);
      const seconds = this.timer % 60;
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    otpButtonText() {
      return this.timer > 0 ? this.formattedTime : this.$t("Resend");
    },
    headerTitle() {
      if (this.register) return this.$t("register");
      if (this.setRegisterInfo) return this.$t("initial information");
      if (this.setRegisterPassword) return this.$t("password");
      if (this.OTPVerifyStep) return this.$t("verify phone");
      return "";
    },
    headerSubtitle() {
      if (this.setRegisterInfo) return this.$t("enter initial information");
      if (this.setRegisterPassword) return this.$t("choose secure password");
      if (this.OTPVerifyStep) {
        return this.$t("verification code sent").replace(
          "<strong></strong>",
          `<strong>${this.phone}</strong>`
        );
      }
      return this.$t("welcome enter phone");
    },
  },
  methods: {
    ruleClass(isValid) {
      if (isValid) return "rule--valid";
      if (this.password.length > 0) return "rule--invalid";
      return "rule--neutral";
    },
    iconColor(isValid) {
      if (isValid) return "green";
      if (this.password.length > 0) return "red";
      return "grey";
    },
    iconName(isValid) {
      if (isValid) return "mdi-check";
      if (this.password.length > 0) return "mdi-close";
      return "mdi-circle";
    },
    returnToLogin() {
      this.$emit("update:signUpSection", false);
      this.$emit("switchMode", false);
    },
    startTimer() {
      this.timer = 120;
      const countdown = setInterval(() => {
        if (this.timer > 0) {
          this.timer--;
        } else {
          clearInterval(countdown);
        }
      }, 1000);
    },
    sendOTPCode() {
      var app = this;
      app.loading = true;
      const valid = this.mobileFormatRule(this.phone);
      if (valid !== true) {
        app.loading = false;
        return;
      }
      this.$axios
        .post(this.$apipoint + "v2/otp/send", {
          mobile: app.phone,
          password: app.password,
        })
        .then((response) => {
          this.OTPVerifyStep = true;
          this.register = false;
          this.startTimer();
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    EditPhone() {
      this.OTPVerifyStep = false;
      this.register = true;
    },
    confirmOTP() {
      var app = this;
      app.loading = true;
      this.$axios
        .post(this.$apipoint + "v2/otp/validate", {
          mobile: app.phone,
          code: app.OTPcode,
          type: app.OTPtypeValidate,
        })
        .then((response) => {
          if (response.data.meta.is_registered == false) {
            app.OTPVerifyStep = false;
            app.setRegisterPassword = true;
          } else {
            // localStorage.setItem('user', response.data.meta)
            // localStorage.setItem('hasaccount', response.data.meta.has_account)
            localStorage.setItem("usermobile", response.data.username);
            // localStorage.setItem("token", response.data.meta.token);
            localStorage.setItem(
              "primaryToken",
              JSON.stringify(response.data.meta.token)
            );
            app.$axios.defaults.headers.common.x_api_key = response.data.meta.token;
            localStorage.setItem("apn", null);
            if (response.data.meta.has_account == true) {
              // set (name + username + avatar) in vuex for showing user data
              app.$store.commit("SET_NAME", response.data.name);
              app.$store.commit(
                "SET_AVATAR",
                response.data.avatar ? response.data.avatar : null
              );
              app.$store.commit("SET_USERNAME", response.data.username);
              app.getAccount(response);
            } else {
              app.$router.push("/business-Info");
            }
          }
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    confirmPassInfo() {
      const { length, upperLower, number, symbol } = this.passwordChecks;
      if (length && upperLower && number && symbol) {
        if (this.password !== this.retypePassword) {
        } else {
          this.setRegisterPassword = false;
          this.setRegisterInfo = true;
        }
      } else {
        // console.log('is not valid')
      }
    },
    confirmInformation() {
      var app = this;
      app.loading = true;
      const lang = app.$root.$i18n.locale;
      this.$axios
        .post(this.$apipoint + "v2/register", {
          lang: lang,
          mobile: app.phone,
          firstname: app.name,
          lastname: app.lastName,
          password: app.password,
        })
        .then((response) => {
          // localStorage.setItem('user', response.data.meta)
          localStorage.setItem("usermobile", response.data.meta.user.username);
          // localStorage.setItem("token", response.data.meta.token);
          localStorage.setItem("primaryToken", JSON.stringify(response.data.meta.token));
          app.$axios.defaults.headers.common.x_api_key = response.data.meta.token;
          app.$router.push("/business-Info");
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
    resendOTP() {
      var app = this;
      if (this.timer === 0) {
        app.sendOTPCode();
        app.startTimer();
      }
    },
    getAccount(value) {
      var app = this;
      app.loading = true;
      this.$axios
        .post(this.$apipoint + "v2/get-user-accounts", {
          headers: {
            x_api_key: value.data.meta.token,
          },
        })
        .then((response) => {
          this.$emit("business-selector", {
            hasAccount: value.data.meta.has_account,
            Authorization: value.data.meta.token,
            userData: response.data.accounts,
          });
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
          app.overlay = false;
        });
    },
  },
};
</script>

<style scoped src="./auth-form.css"></style>
